import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import NosaLogo from "@/components/NosaLogo";
import { EASE, scrollToId } from "@/lib/scroll";

const LINKS = [
  { id: "beneficii", label: "Beneficii" },
  { id: "reteta", label: "Rețetă" },
  { id: "despre", label: "Despre" },
  { id: "povestea", label: "Povestea" },
  { id: "contact", label: "Contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    setTimeout(() => scrollToId(id), open ? 350 : 0);
  };

  return (
    <>
      <header
        className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
          scrolled
            ? "border-b border-gold/15 bg-ink/85 backdrop-blur-xl"
            : "border-b border-transparent bg-transparent"
        }`}
      >
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
          <NosaLogo />
          <nav className="hidden items-center gap-10 lg:flex">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-link-${l.id}`}
                onClick={() => go(l.id)}
                className="group relative font-mono text-[11px] uppercase tracking-[0.28em] text-stone transition-colors duration-300 hover:text-cream"
              >
                {l.label}
                <span className="absolute -bottom-1.5 left-0 h-px w-0 bg-gold transition-all duration-500 group-hover:w-full" />
              </button>
            ))}
            <button
              data-testid="nav-cta-contact"
              onClick={() => go("contact")}
              className="rounded-full border border-gold/50 px-6 py-2.5 font-mono text-[11px] uppercase tracking-[0.22em] text-gold transition-all duration-500 hover:bg-gold hover:text-ink"
            >
              Contactează-ne
            </button>
          </nav>
          <button
            data-testid="nav-mobile-toggle"
            className="text-gold lg:hidden"
            onClick={() => setOpen(!open)}
            aria-label={open ? "Închide meniul" : "Deschide meniul"}
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </header>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -24 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -24 }}
            transition={{ duration: 0.45, ease: EASE }}
            className="fixed inset-x-0 top-0 z-40 flex min-h-screen flex-col justify-center gap-2 bg-ink/97 px-8 pt-24 backdrop-blur-2xl lg:hidden"
          >
            {LINKS.map((l, i) => (
              <motion.button
                key={l.id}
                initial={{ opacity: 0, x: -24 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.08 * i, duration: 0.5, ease: EASE }}
                data-testid={`nav-mobile-link-${l.id}`}
                onClick={() => go(l.id)}
                className="border-b border-gold/10 py-5 text-left font-serif text-4xl text-cream"
              >
                {l.label}
              </motion.button>
            ))}
            <p className="mt-10 font-mono text-[10px] uppercase tracking-[0.3em] text-gold/60">
              Hrană umedă super premium · România
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
